import { render } from "./AddThemeModal.vue?vue&type=template&id=444dcb62"
import script from "./AddThemeModal.vue?vue&type=script&lang=js"
export * from "./AddThemeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__